"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _edSystem = require("@eduact/ed-system");
var _SingleOtpInput = _interopRequireDefault(require("./SingleOtpInput"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var OtpInput = function OtpInput(_ref) {
  var inputsNum = _ref.inputsNum,
    inputStyle = _ref.inputStyle,
    separator = _ref.separator,
    initValue = _ref.initValue,
    onChange = _ref.onChange,
    _ref$isNumberInput = _ref.isNumberInput,
    isNumberInput = _ref$isNumberInput === void 0 ? true : _ref$isNumberInput;
  var _useState = (0, _react.useState)(-1),
    _useState2 = _slicedToArray(_useState, 2),
    activeInput = _useState2[0],
    setActiveInput = _useState2[1];
  var _useState3 = (0, _react.useState)(Array(inputsNum).fill('').map(function (_, index) {
      var _initValue$index;
      return (_initValue$index = initValue === null || initValue === void 0 ? void 0 : initValue[index]) !== null && _initValue$index !== void 0 ? _initValue$index : '';
    })),
    _useState4 = _slicedToArray(_useState3, 2),
    otpValues = _useState4[0],
    setOtpValues = _useState4[1];

  // Focus Input Methods

  var focusInput = (0, _react.useCallback)(function (inputIndex) {
    var selectedIndex = Math.max(Math.min(inputsNum - 1, inputIndex), 0);
    setActiveInput(selectedIndex);
  }, [inputsNum]);
  var focusPrevInput = (0, _react.useCallback)(function () {
    focusInput(activeInput - 1);
  }, [activeInput, focusInput]);
  var focusNextInput = (0, _react.useCallback)(function () {
    focusInput(activeInput + 1);
  }, [activeInput, focusInput]);

  // On Input Value Change Methods
  var validateValue = (0, _react.useCallback)(function (val) {
    var _val = val;
    if (!isNumberInput || !_val) {
      return _val;
    }
    return Number(_val) >= 0 ? _val : '';
  }, [isNumberInput]);
  var handleOtpChange = (0, _react.useCallback)(function (otp) {
    var otpValue = otp.join('');
    onChange === null || onChange === void 0 ? void 0 : onChange(otpValue);
  }, [onChange]);
  var updateCode = (0, _react.useCallback)(function (value) {
    var toBeUpdatedValues = _toConsumableArray(otpValues);
    toBeUpdatedValues[activeInput] = value[0] || '';
    setOtpValues(toBeUpdatedValues);
    handleOtpChange(toBeUpdatedValues);
  }, [activeInput, otpValues]);
  var handleOnChange = (0, _react.useCallback)(function (e) {
    var value = validateValue(e.currentTarget.value);
    if (!value) {
      e.preventDefault();
      return;
    }
    updateCode(value);
    focusNextInput();
  }, [updateCode, focusNextInput, validateValue]);

  // On Keydown
  var handleOnKeydown = (0, _react.useCallback)(function (e) {
    var key = e.key;
    switch (key) {
      case 'Delete':
      case 'Backspace':
        e.preventDefault();
        if (otpValues[activeInput]) {
          updateCode('');
        } else {
          focusPrevInput();
        }
        break;
      case 'ArrowLeft':
        e.preventDefault();
        focusPrevInput();
        break;
      case 'ArrowRight':
        e.preventDefault();
        focusNextInput();
        break;
      default:
        if (key.match(/^[^a-zA-Z0-9]$/)) {
          e.preventDefault();
        }
        break;
    }
  }, [activeInput, focusNextInput, focusPrevInput, updateCode]);

  // On Focus
  var handleOnFocus = (0, _react.useCallback)(function (index) {
    return function () {
      focusInput(index);
    };
  }, [focusInput]);
  var onBlur = (0, _react.useCallback)(function () {
    setActiveInput(-1);
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_edSystem.FlexLayout, {
    alignItems: 'center'
  }, Array(inputsNum).fill('').map(function (_, index) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: "SINGLE-OTP-".concat(index)
    }, /*#__PURE__*/_react["default"].createElement(_SingleOtpInput["default"], {
      type: isNumberInput ? 'number' : 'text',
      onChange: handleOnChange,
      onKeyDown: handleOnKeydown,
      onFocus: handleOnFocus(index),
      focus: activeInput === index,
      value: otpValues === null || otpValues === void 0 ? void 0 : otpValues[index],
      onBlur: onBlur,
      style: inputStyle
    }), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, index < inputsNum - 1 && separator));
  }));
};
var _default = /*#__PURE__*/(0, _react.memo)(OtpInput);
exports["default"] = _default;